import * as React from "react";
import { forwardRef } from "react";
const SvgPhoto = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    ref={ref}
    {...props}
  >
    <path d="M3.875 1c-.499 0-.9.558-.9 1.25v.25H.75a.75.75 0 0 0-.75.75v5c0 .416.335.75.75.75h8.5c.416 0 .75-.334.75-.75v-5a.75.75 0 0 0-.75-.75H7.025v-.25c0-.692-.401-1.25-.9-1.25zM1.25 3.25a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5m3.75 0a2.5 2.5 0 0 1 2.5 2.5A2.5 2.5 0 0 1 5 8.25a2.5 2.5 0 0 1-2.5-2.5A2.5 2.5 0 0 1 5 3.25M5 4.5a1.25 1.25 0 0 0-1.25 1.25A1.25 1.25 0 0 0 5 7a1.25 1.25 0 0 0 1.25-1.25A1.25 1.25 0 0 0 5 4.5" />
  </svg>
);
const ForwardRef = forwardRef(SvgPhoto);
export default ForwardRef;
